import { render, staticRenderFns } from "./commonTime.vue?vue&type=template&id=30388152&scoped=true"
import script from "./commonTime.vue?vue&type=script&lang=js"
export * from "./commonTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30388152",
  null
  
)

export default component.exports